export const LEN = ["Full toss", "Yorker", "Full length", "Good length", "Short of good length", "Short length"];
export const LINE = ["wide outside off", "outside off", "at the stumps", "down leg", "wide down leg"];

/** The scorer's length text is free-form, so match on keywords. Returns a row of LEN, or null when it is not recognised. */
export const lengthIndex = (raw?: string | null): number | null => {
  const t = (raw ?? "").toLowerCase().replace(/[_-]+/g, " ").trim();
  if (!t) return null;
  if (/full ?toss|beamer/.test(t)) return 0;
  if (/yorker|block ?hole/.test(t)) return 1;
  if (/short of (a )?(good|length)|back of (a )?length/.test(t)) return 4;
  if (/short|bouncer/.test(t)) return 5;
  if (/good/.test(t)) return 3;
  if (/full|half ?volley|over ?pitched/.test(t)) return 2;
  return null;
};

/** Column of LINE for a right-hander (0 = wide outside off ... 4 = wide down leg), or null when not recognised. */
export const lineIndex = (raw?: string | null): number | null => {
  const t = (raw ?? "").toLowerCase().replace(/[_-]+/g, " ").trim();
  if (!t) return null;
  const wide = /wide/.test(t);
  if (/leg|body/.test(t)) return wide ? 4 : 3;
  if (/outside off|off side|fourth stump|4th stump|channel/.test(t)) return wide ? 0 : 1;
  if (/off/.test(t) && !/stump/.test(t)) return wide ? 0 : 1;
  if (/stump|middle|straight|line|off/.test(t)) return 2;
  return null;
};

/**
 * The scorer app pre-fills line and length, so a match where nobody changed them has every ball in one cell (QA: all balls were
 * "outside off" / "full"). Real data has more than one distinct combination; a single one means "not recorded".
 */
export const pitchRecorded = (balls: { line: string | null; length: string | null }[]) =>
  new Set(balls.filter((b) => b.line || b.length).map((b) => `${b.line ?? ""}|${b.length ?? ""}`)).size > 1;
